import {MutationTree} from "vuex";
import {UserRolesState} from "@/store/user_management/roles/types";

export const mutations: MutationTree<UserRolesState> = {
  setUserRoles: (state, payload) => {
    state.userRoles = payload;
  },
  setUserRoleItem: (state, payload) => {
    state.userRoleItem = payload;
  }
}